import { createPinia, getActivePinia } from 'pinia'
import { createApp, defineAsyncComponent } from 'vue'

import IbhFastbookingContainer from '../../vue/src/components/IbhFastbooking/IbhFastbookingContainer.vue'

const fastbooking = defineAsyncComponent(() => import('FastBooking/FastBooking'))
const flightPlusHotel = defineAsyncComponent(() => import('FastBooking/FlightPlusHotel'))

const app = createApp()

let pinia = getActivePinia()
if (!pinia) {
  pinia = createPinia()
}

app.use(pinia)

app
  .component('IbhFastbookingContainer', IbhFastbookingContainer)
  .component('IbhFastbooking', fastbooking)
  .component('FhFastbooking', flightPlusHotel)

app.mount('#ibh-fastbooking')
